import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import OrgTreeSelector from 'scoreboard/organizations/org-multi-tree-selector'
import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import projects from 'scoreboard/projects/projects'
import template from 'scoreboard/components/multi-tree-selector.hbs'
import globals from 'scoreboard/components/globals'

const OrgFilter = OrgTreeSelector.extend({

	className: 'multi-tree-selector org-permissions-form tree-selector-form',

	createGardener: function() {
		return new OrgGardener({
			showProjectSelector: _.get(this.options, 'showProjectSelector', false),
			projectId: this.options.projectId || projects.id,
			descendants:true,
			ordered:false,
			id: globals.orgId,
			permissions: true,
			section: this.options.section
		})
	},

	/**
	 *
	 * @param {Number|String} options.projectId will be converted to a number
	 */
	initialize(options = {}) {
		OrgTreeSelector.prototype.initialize.apply(this, arguments)
		this.data = _.defaults({}, this.options.data)

		//transform the data to something the org tree selector understands
		this._previousSelections = {}
		_.each(this.data.values || [], id => {
			this._previousSelections[id] = _.defaults({cascade: false},
				this.data.metadata[id])
		})
		_.each(this.data.ancestorValues || [], id => {
			this._previousSelections[id] = _.defaults({cascade: true},
				this.data.metadata[id])
		})

		//pass along the inherited's form view's change event so the filter
		//detail view can response appropriately
		this.formView.on('change', this.trigger.bind(this, 'change'))
	},

	_renderInitialSelections: function() {
		//we're not returning the descendant info with the report because it
		//sucks to have to compute that information and besides the
		//org gardener has to get the descendant info anyway so let's wait until
		//the tree has been loaded and pull the descendant info from there.
		//this method waits until the tree is loaded but before the initial selection
		//is render, making it suitable to insert the descendant information here
		_.each(this._previousSelections, selection => {
			let node = this.gardener.tree.get(selection.id)
			if (node) {
				selection.descendants = node.descendants
			} else {
				//it would be pain technically to get the correct number, but
				//arguably it more secure this way since the user shouldn't know
				//the descendant orgs anyway.
				selection.descendants = 0
			}
		})

		OrgTreeSelector.prototype._renderInitialSelections.apply(this, arguments)
	},

	oldSelections() {
		return this._previousSelections
	},

	context() {
		return {
			title: ': ' + i18n.get('report.customReport.specificOrganizations'),
			treeIcon: 'browse',
			treeIconClass: 'icon-browse',
			treeLabel: i18n.get('common.organization.organizations'),
			selectedLabel: i18n.get('report.metricComparisonReport.selectedOrganizations'),
			noneSelectedKey: 'admin.group.organizationPermissions.none',
			emptyTreeMessage: i18n.get('common.organization.noOrganizations'),
			cascadeHelpKey: 'report.customReport.orgFilter.cascade.help',
			submitLabel: i18n.get('common.done')
		}
	},

	_template: function(ctx) {
		return template(_.defaults(ctx, {
			noDialog: true
		}))
	},

	render: function() {
		OrgTreeSelector.prototype.render.apply(this, arguments)

		//taken care of by the filter view
		this.$('.dialog-header,.dialog-footer').remove()

		return this
	},

	test: function() {
		return _.keys(this.newSelections()).length == 0 ?
			i18n.get('common.error.mustSelect.organization') : null
	},

	gather: function() {
		this.data.values = []
		this.data.ancestorValues = []
		_.each(this.newSelections(), (cascade, id) => {
			let a = cascade ? this.data.ancestorValues : this.data.values
			a.push(id)
		})
		this.data.metadata = _.cloneDeep(this.selectedItemCache)
		return this.data
	}


})

export default OrgFilter

OrgFilter.__filename__ = 'reports/wizard/filter-meta/org-filter.js'
